<template>
  <div class="shop-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="shop-page__container">
      <div class="shop-page__info sides-padding">
        <div class="container">
          <ShopAddressComponent :data="shop" />
        </div>
      </div>
      <div v-if="shop.images && shop.images.length" class="shop-page__photos sides-padding">
        <div class="container">
          <div class="shop-page__photos-inner">
            <ImgComponent class="image" v-for="(item, i) in shop.images" :key="i" :head_img="item.img" />
          </div>
        </div>
      </div>
      <div class="shop-page__products sides-padding">
        <div class="container">
          <h3>Популярные товары магазина</h3>
          <div class="shop-page__products-inner">
            <ProductCardComponent v-for="(item, i) in popular_products" :key="i" :data="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import SHOP_ITEM_PAGE from "@/graphql/pages/ShopItemPage.graphql";
import ShopAddressComponent from "../components/ShopAddressComponent.vue";
import ProductCardComponent from "components/product/ProductCardComponent.vue";
import ImgComponent from "components/ImgComponent.vue";

export default {
  name: "ShopOpenPage",
  async asyncData({ apollo, store, route }) {
    await apollo.defaultClient
      .query({
        query: SHOP_ITEM_PAGE,
        variables: {
          id: parseInt(route.params.id),
        },
      })
      .then(({ data }) => {
        store.state.shop_page.shop_item = data.baby_shops_item;
        store.state.all_brands = data.brands || [];
        store.state.shop_page.shop_item.popular_products = data.products_paginate;
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  components: { ProductCardComponent, ShopAddressComponent, BreadcrumbsComponent, ImgComponent },
  data() {
    return {};
  },
  mounted() {
    if (this.$route.hash) {
      document.querySelector(this.$route.hash).scrollIntoView({ block: "start", behavior: "smooth" });
    }
  },
  computed: {
    links() {
      return [{ title: "Магазин", route: { name: "shop" } }, { title: this.shop.title }];
    },
    shop() {
      return this.$store.state.shop_page.shop_item;
    },
    popular_products() {
      return this.$store.state.shop_page.shop_item.popular_products.data;
    },
  },
  metaInfo() {
    return {
      title: this.shop.meta_title || this.shop.title,
      description: this.shop.meta_description,
      keywords: this.shop.meta_keywords,
      meta: [
        {
          vmid: "og:image",
          name: "og:image",
          content: this.shop.head_img
            ? this.$store.state._env.MEDIA_ENDPOINT + this.shop.head_img.path
            : null,
        },
      ],
    };
  },
};
</script>

<style lang="stylus">
.shop-page {
  width 100%
  display grid
  grid-gap 50px

  &__container {
    display grid
    align-items start
    gap 50px
  }

  &__info {
    .container {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }
  }

  &__products-inner {
    display grid
    grid-template-columns repeat(6, 1fr)
    gap 30px
    +below(1200px) {
      grid-template-columns repeat(4, 1fr)
    }
    +below(960px) {
      grid-template-columns repeat(3, 1fr)
    }
    +below(768px) {
      grid-gap 20px
    }
    +below(680px) {
      grid-template-columns repeat(2, 1fr)
    }
    +below(420px) {
      grid-template-columns 1fr
    }
  }

  &__photos-inner {
    display grid
    grid-template-columns repeat(4, 1fr)
    gap 30px
    +below(1200px) {
      grid-template-columns 1fr
      gap 30px
    }

    & .image {
      width 100%
      max-width 303px
      height 100vh
      max-height 203px
      border-radius 15px

      +below(1200px) {
        max-width 100%
        max-height 100%
      }
    }
  }
}
</style>
